import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Seo } from "@/components/Seo";

const CONTENT = {
  privacy: {
    title: "Privacy Policy.",
    path: "/privacy",
    description: "How DISJINX collects, uses and protects your personal information.",
  },
  terms: {
    title: "Terms and Conditions.",
    path: "/terms",
    description: "The terms that govern use of DISJINX's website and automation services.",
  },
};

export default function LegalNotice({ kind }) {
  const c = CONTENT[kind];
  return (
    <main data-testid={`legal-${kind}-page`} className="pt-40 pb-32 lg:pt-48">
      <Seo title={`${c.title.replace(/\.$/, "")} — DISJINX`} description={c.description} path={c.path} noindex />
      <div className="mx-auto max-w-2xl px-6">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-neutral-500">Legal</p>
          <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight lg:text-5xl">{c.title}</h1>
          <p className="mt-8 text-base leading-relaxed text-neutral-600">
            We're finalising this document and will publish it here shortly. In the meantime, if you have any
            questions, email us at{" "}
            <a
              href="mailto:disjinx.support@gmail.com"
              data-testid={`legal-${kind}-email-link`}
              className="font-semibold text-neutral-950 underline underline-offset-2"
            >
              disjinx.support@gmail.com
            </a>
            .
          </p>
          <Link
            to="/"
            data-testid={`legal-${kind}-home-link`}
            className="group mt-10 inline-flex items-center gap-2 border border-neutral-300 px-7 py-4 text-sm font-semibold text-neutral-950 transition-colors duration-200 hover:border-neutral-950"
          >
            <ArrowLeft className="h-4 w-4 transition-transform duration-200 group-hover:-translate-x-0.5" />
            Back to home
          </Link>
        </motion.div>
      </div>
    </main>
  );
}
